import apiService from "services/apiService";
import { AxiosResponse } from "axios";

/**
 * Company-wide leave settings. Currently just the month the leave year starts
 * from (1 = January … 12 = December). `yearStartYear` is read-only (derived by
 * the backend).
 */
export interface CompanyLeaveSettings {
  yearStartMonth: number;
  yearStartYear?: number;
}

export class CompanyLeaveSettingsManager {
  private url = "api/company-leave-settings";

  async get(): Promise<AxiosResponse<CompanyLeaveSettings>> {
    return await apiService.get(this.url);
  }

  async update(yearStartMonth: number): Promise<AxiosResponse<CompanyLeaveSettings>> {
    return await apiService.put(this.url, { yearStartMonth });
  }
}

const companyLeaveSettingsManager = new CompanyLeaveSettingsManager();
export default companyLeaveSettingsManager;
